import { Component, OnInit } from "@angular/core";
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { ThemeService } from "./theme/components/theme.service";
import { MessageBroadcasterService } from "./services/message.service";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "./services/authentication.service";
import { HttpClient } from "@angular/common/http";
import { ChatService } from "./pages/chat/chat.service";
import { LoggerService } from "./core/logger.service";
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized } from "@angular/router";
import { LanguageService } from "./core/language.service";
import { Socket } from "ngx-socket-io";
import { SocketEvents } from "./services/app.constants";
import { Helpers } from "./services/app.helpers";
import * as moment from "moment";

declare let $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [
    trigger("slideInOut", [
      state("in", style({
        "margin-left": "250px"
      })),
      state("out", style({
        "margin-left": "70px"
      })),
      transition("in => out", [
        animate("200ms ease-in")
      ]),
      transition("out => in", [
        animate("200ms ease-in")
      ])
    ])
  ]
})
export class AppComponent implements OnInit {
  title = "Train your pulse";
  connection: any;
  proxy: any;
  chatProxy: any;
  isLoaderActive = true;

  constructor(private translateService: TranslateService, private themeService: ThemeService, private messageService: MessageBroadcasterService,
    private authService: AuthenticationService, private logger: LoggerService, private router: Router,
    private languageService: LanguageService, private socket: Socket, private helpers: Helpers) {

    this.languageService.setDefaultLanguage();
    moment.locale(this.helpers.getLocale());

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      moment.locale(this.helpers.getLocale());
    });
  }

  ngOnInit(): void {
    this.authService.loginSuccess.subscribe(() => {
      this.authenticateSocketIo();
    });

    this.authService.logoutSuccess.subscribe((data) => {
      this.logoutSockets(data);
    });

    if (this.authService.isUserAuthenticated()) {
      this.authenticateSocketIo();
    }

    this.socket.fromEvent<any>(SocketEvents.Connect).subscribe(x => {
      this.authenticateSocketIo();
    });

    this.router.events.subscribe((x) => {
      if (x instanceof RoutesRecognized) {
        try {
          let lastChild = x.state.root.firstChild;
          let data = x.state.root.data;

          while (lastChild !== undefined && lastChild !== null) {
            data = lastChild.data;
            lastChild = lastChild.firstChild;
          }

          if (data && data.title) {
            document.title = "Social Collaboration Platform | " + this.translateService.instant(data.title);
          }
        } catch (err) {
          console.log(err);
        }
      }


      if (x instanceof NavigationEnd) {
        const xx = x as NavigationEnd;
        if (xx.url === "/chat") {
          this.isLoaderActive = false;
        } else {
          this.isLoaderActive = true;
        }
      }
    });
  }

  private logoutSockets(token: string) {
    this.socket.emit(SocketEvents.LogoutSockets, { token });
  }

  private authenticateSocketIo() {
    if (!this.authService.getJwtToken()) return;

    this.socket.emit(SocketEvents.Authorize, { token: this.authService.getJwtToken() });
  }

  private initializeWebSockets() {
    const conn = new WebSocket(`${environment.socketsPath}?token=${this.authService.getJwtToken()}`);
    conn.onopen = (e) => {
      this.logger.log("Websockets connected");
    };

    conn.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data);
        this.messageService.broadcastMessage(data);
      } catch (err) { }
    };
  }

  get isOpen() {
    return this.themeService.animationState;
  }
}
